// /* eslint-disable no-useless-constructor */
// import networkList from '../constants/networkList';
// import axios from 'axios';
// import { Modal } from 'antd';
// import Storage from './local-store';

// const { base_url } = networkList;

// const HttpClient = axios.create({
//     baseURL: base_url,
//     headers: {
//         'Content-Type': 'application/json',
//         "accept": "application/json"
//     }
// });
// export default function postService(url, method, data) {
//     const token = JSON.parse(Storage.get('token'));
//     return HttpClient({
//         method: method,
//         url: url,
//         data: data,
//         headers: {
//             'authorization': token
//         }
//     }).then(function (response) {
//         const { data } = response;
//         const { status } = response;
//         if (status === 200) {
//             //if (data.status) {
//                 //return data;
//             //} else {
//                 // Modal.error({title: data.message});
//                 return data;
//             //}
//         } else if (status === 401) {
//             Modal.error({
//                 'title': "Unauthorised Access",
//                 'content': `${data.message}`,
//                 zIndex: 1045,
//                 onOk: () => {
//                     localStorage.clear();
//                     window.location.replace('/');
//                 }
//             })
//         } else if (status === 402 || status === 400) {
//             Modal.error({
//                 'title': "Error",
//                 'content': `${data.message}`,
//                 zIndex: 1045,
//                 // onOk: () => {
//                 //     localStorage.clear();
//                 //     window.location.replace('/');
//                 // }
//             })
//         } else if (status === 500) {
//             Modal.error({
//                 'title': "Encountered some error. Please refresh",
//                 'content': `${data.message}`,
//                 zIndex: 1045,
//                 // onOk: () => {
//                 //     localStorage.clear();
//                 //     window.location.replace('/');
//                 // }
//             })
//         } else {
//             return false;
//         }
//     }).catch(async function (error) {
//         console.log(error.response);
//         let { status, data } = error.response ? error.response : {};
//         if (status && status === 401) {
//             Modal.error({
//                 'title': "Unauthorised Access",
//                 'content': `${data.message}`,
//                 zIndex: 1045,
//                 onOk: () => {
//                     localStorage.clear();
//                     window.location.replace('/');
//                 }
//             })
//             return false;
//         } else if (status === 402 || status === 400) {
//             Modal.error({
//                 'title': "Error",
//                 'content': `${data.message}`,
//                 zIndex: 1045,
//                 // onOk: () => {
//                 //     localStorage.clear();
//                 //     window.location.replace('/');
//                 // }
//             })
//         } else {
//             return false;
//         }


//     });
// }


// // function logout() {
// //     try {
// //         const { logout } = networkList;
// //         const id = JSON.parse(Storage.get('id'));
// //         Modal.destroyAll();
// //         this.setState({
// //             "id": id,
// //         })
// //         this.setState((state) => ({ btnloading: true }), () => {
// //             postService(logout, 'GET', {
// //                 "id": this.state.id,
// //             }).then(res => {
// //                 if (res.status) {
// //                     localStorage.clear();
// //                     window.location.replace('/');
// //                 } else {
// //                     localStorage.clear();
// //                     window.location.replace('/');
// //                 }

// //             })
// //         });
// //     } catch (error) {
// //         console.log(error);
// //         localStorage.clear();
// //         window.location.replace('/');
// //     }
// // }


import networkList from '../constants/networkList';
import axios from 'axios';
import { Modal } from 'antd';
import Storage from './local-store';
import { showLoader, hideLoader } from './loader'; // adjust path if needed

const { base_url } = networkList;

const HttpClient = axios.create({
  baseURL: base_url,
  headers: {
    'Content-Type': 'application/json',
    accept: 'application/json',
  },
});

export default async function postService(url, method, data) {
  const token = JSON.parse(Storage.get('token'));
  const currenthref = window.location.pathname;

//   showLoader(); // 🔄 Start loader

  try {
    const response = await HttpClient({
      method,
      url,
      data,
      headers: {
        authorization: token,
      },
    });

    const { data: responseData, status } = response;

    if (status === 200) {
      hideLoader();
      return responseData;
    } else if (status === 401) {
      hideLoader();
      Modal.error({
        title: 'Unauthorised Access',
        content: `${responseData.message}`,
        zIndex: 1045,
        onOk: () => {
          localStorage.clear();
          window.location.replace('/');
        },
      });
      return false;
    } else {
      hideLoader();
      Modal.error({
        title: 'Error',
        content: `Unexpected error occurred.`,
        zIndex: 1045,
        onOk: () => {
        //   showLoader();
        //   window.location.reload(true);
        window.location.replace('/');
        
        },
      });
      return false;
    }
  } catch (error) {
    const { status, data: errorData } = error.response || {};

    // ✅ Retry only if status === 400
    if (status === 400) {
      let attempt = 1;
      const maxRetries = 3;
      showLoader();
      while (attempt <= maxRetries) {
        try {
          const retryResponse = await HttpClient({
            method,
            url,
            data,
            headers: {
              authorization: token,
            },
          });

          const { data: retryData, status: retryStatus } = retryResponse;

          if (retryStatus === 200) {
            hideLoader();
            return retryData;
          }

        } catch (retryError) {
          attempt++;

          if (attempt > maxRetries) {
            hideLoader();

            localStorage.setItem('errorMessage', errorData.message);
            localStorage.setItem('lastVisitedPath', currenthref);

            Modal.error({
              title: 'Error',
              content: `${errorData.message || 'Bad request'}`,
              zIndex: 1045,
              onOk: () => {
                showLoader();
                window.location.reload(true);
              },
            });
            return false;
          }

          // optional delay
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
      }
    } else if (status === 401) {
      hideLoader();
      Modal.error({
        title: 'Unauthorised Access',
        content: `${errorData.message || 'Unauthorized access'}`,
        zIndex: 1045,
        onOk: () => {
          localStorage.clear();
          window.location.replace('/');
        },
      });
      return false;
    } else if (status === 402){
        hideLoader();
        Modal.error({
          title: 'Something went wrong',
          content: 'Please try again later.',
          zIndex: 1045,
          onOk: () => {
          //   showLoader();
          localStorage.clear();
          window.location.reload(true);
          },
        });
        return false;
      }else {
      hideLoader();
      Modal.error({
        title: 'Something went wrong',
        content: 'Please try again later.',
        zIndex: 1045,
        onOk: () => {
        //   showLoader();
        window.location.reload(true);
        },
      });
      return false;
    }
  }
}